import React from 'react'
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';

const PromptInvoiceSettings = ({ open, onClose, onClick }) => {
  const handleClose = (event, reason) => {
    if (reason === 'backdropClick') {
      return; // Prevent closing when clicking outside
    }
    onClose(); // Allow closing when explicitly called (e.g., button click)
  };
  return (
    <Dialog disableRestoreFocus open={open} onClose={handleClose} aria-labelledby="invoice-settings-title">
      <DialogTitle id="invoice-settings-title" sx={{ fontSize: '20px' }}>Welcome to Your First Invoice Creation!</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Before you proceed, let’s make sure your invoice settings are perfectly tailored for your business.
          This is a great moment to review and customize your invoice preferences to ensure everything looks just right.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Later
        </Button>
        <Button onClick={onClick} color="primary" variant="contained" autoFocus>
          Update Invoice Settings
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default PromptInvoiceSettings